export enum FrontendExperience {
  /**
   * Simple Due Diligence is required for purchases
   */
  SDD_IN_STORE = 'SDD_IN_STORE',
  /**
   * Player is under the required age limit
   */
  PLAYER_UNDER_AGE = 'PLAYER_UNDER_AGE',
  /**
   * Player must verify on login
   */
  MUST_VERIFY_NOW = 'MUST_VERIFY_NOW',

  /**
   * TODO: TBA
   */
  SELF_EXCLUSION = 'SELF_EXCLUSION',
  CDD_REQUIRED = 'CDD_REQUIRED',
}
